import Controller from '../framework/base';

export default class extends Controller {
  connect() {
    this.render(null, { replace: true });
  }
}
